export enum CredentialType {
  EnergyStar = 'ENERGY STAR',
  EvChargingProvider = 'EV Charging Provider',
  SolarProvider = 'Solar Provider',
  Utility = 'Utility',
  UtilityManagement = 'Utility Management',
}
